/**
 * Deep clones an object.
 * This is mostly used to clone an object from Vuex store locally into the state of a Vue component.
 *
 * @param {Object} obj Object to be clones
 * @return Object
 *
 */
function deepClone(obj) {
    if (obj == null) {
        return obj;
    }

    // Note: `obj` needs to be serialisable (no functions)
    // which should always be the case with Vuex store state
    //
    return JSON.parse(JSON.stringify(obj));
}

export default deepClone;
